
import { post } from '@/utils/network/axios-helper';
import type { IParamsType, ISudentInfo } from '@/utils/ctype';

export interface IItem{
  course: string;
  is_confirm: number;
  score: number;
  status: number;
  update_time: number;
}

export interface IGetExamInfo {
  listening: IItem;
  reading: IItem;
  writing:IItem;
  record_id: number;
  type: number;
}

export const getExamInfo = async (params?: IParamsType) => {
  return post<IGetExamInfo>('/api/simulate/get-exam-info', params);
};

export const getStudentInfo = async () => {
  return post<ISudentInfo>('/api/student/get-info', {});
};